// extracted by mini-css-extract-plugin
module.exports = {"box":"Banderole_box__2p2dA","top":"Banderole_top__1n7bR","bottom":"Banderole_bottom__fAyl-"};